/** 又拍云配置 */
export const upyunConfig = {
  api: "//v0.api.upyun.com/",
  bucket: "weixue-hztbc",
  apiSecret: "tbQ8Z1aoYwu5Kitxxzet6Wzqv0s=",
  domain: "//res.eweixue.com"
};

/**
 * 格式化又拍云给的文件路径
 * @param url 默认文件路径
 * @param mode full: 带协议的完整路径 proxy: 走反向代理的路径 auto(默认): 自适应协议头的路径
 */
export function formatUpyunUrl(
  url: string,
  mode: "full" | "proxy" | "auto" = "auto"
) {
  if (mode === "full") {
    return `https:${upyunConfig.domain}${url}`;
  } else if (mode === "proxy") {
    return `/res${url}`;
  } else {
    return `${upyunConfig.domain}${url}`;
  }
}
